<mat-toolbar>
  <div style="width: 100%; text-align: center">
    <a href="/tng">
      <img src="assets/logo-minimal.svg" style="height: 1.2em; margin-top: 20px"/>
    </a>
  </div>
</mat-toolbar>

<div class="wrapper">
  <div class="background-img top-right-rectangle"></div>
  <div class="content">
    <div class="text-center">

      <div *ngIf="errOccurred" style="font-size: large">
        Dieser Einladungslink ist ungültig
      </div>

      <div *ngIf="!errOccurred && loading" class="w-100">
        <mat-spinner style="margin: auto"></mat-spinner>
      </div>
      <ng-container *ngIf="!loading && invitation">
        <h1 class="blue">Einladung als Kooperationspartner von
          <strong>{{invitation._embedded.invitingOfficeAllocation._embedded.employee | coopEmployeeName}}</strong></h1>
        <br/>

        <p>
          Sie wurden von {{invitation._embedded.invitingOfficeAllocation._embedded.employee | coopEmployeeName}} aus
          {{getOfficeName(invitation._embedded.invitingOfficeAllocation._embedded.office)}} ({{invitation._embedded.invitingOfficeAllocation._embedded.office._embedded.company.name}})
          eingeladen, eine Kooperation einzugehen.
        </p>
        <div [ngSwitch]="getStatus()">
          <ng-container *ngSwitchCase="'CREATED'">
            <mat-form-field style="width: min(30em, 95%)" appearance="fill" *ngIf="providerAgentOptions?.length">
              <mat-label>Einladung beantworten aus dem Standort</mat-label>
              <mat-select [(ngModel)]="providerAgent" name="providerAgent">
                <mat-option *ngFor="let option of providerAgentOptions" [value]="option">
                  {{option._embedded.office.name}} - {{option._embedded.activity.name}}
                  ({{option._embedded.employee | coopEmployeeName}})
                </mat-option>
              </mat-select>
            </mat-form-field>
            <br/>
            <button mat-raised-button (click)="deny(invitation)" [disabled]="denying || accepting">
              <mat-spinner *ngIf="denying" diameter="16" style="display: inline-block"></mat-spinner>
              Einladung ablehnen
            </button>&nbsp;&nbsp;
            <button mat-raised-button (click)="accept(invitation)" color="primary" [disabled]="denying || accepting">
              <mat-spinner diameter="16" style="display: inline-block" *ngIf="accepting"></mat-spinner>
              Einladung annehmen
            </button>
          </ng-container>
          <div *ngSwitchCase="'NO_OFFICE_ALLOCATION'" class="text-center">
            <mat-icon color="primary" class="inline-icon">warning</mat-icon>
            Ihr Account ist noch nicht mit Ihren personalisierten Inhalten verknüpft.
            Klicken Sie dafür bitte zuerst in Ihrer Einladungsmail auf den Link "Zur Registrierung" und loggen Sie
            sich erneut ein.
            Sie haben noch keine Einladungsmail erhalten oder Ihr Einladungslink ist abgelaufen? Dann wenden Sie sich
            gerne an den Dr. Klein B2B-Support.
          </div>
          <ng-container *ngSwitchCase="'DENIED'">
            <h2>Diese Einladung wurde abgelehnt.</h2> <br/><br/><a href="/tng/contacts/cooperations">
            <button mat-raised-button color="primary">Weiter</button>
          </a>
          </ng-container>
          <ng-container *ngSwitchCase="'ACCEPTED'">
            <h2>Diese Einladung wurde angenommen.</h2> <br/><br/>
            <a href="/tng/contacts/cooperations">
              <button mat-raised-button color="primary">Weiter</button>
            </a>
          </ng-container>
      <ng-container *ngSwitchDefault>
        Ein technischer Fehler ist aufgetreten: Unbekannter Status: {{invitation.status}}
      </ng-container>
    </div>
    </ng-container>

    <div>
      <br/>
      <br/>
      <span style="font-size: large">Ihr Kontakt bei Dr. Klein</span>
    </div>
  </div>
</div>
<div class="display-flex-center margin-top-bottom-3">
  <div class="info-box">
    <div class="info-image">
      <img src="assets/support.svg" style="height: 112px;"/>
    </div>
    <div class="info-text">
      <h1 class="black">Dr. Klein B2B-Support</h1>
      <h4>First Level Support</h4>
      <table>
        <tr>
          <td>
            <mat-icon color="primary" style="vertical-align: middle; margin-right: 15px">location_on</mat-icon>
          </td>
          <td>
            Hansestraße 14 <br/>
            23558 Lübeck
          </td>
        </tr>
        <tr>
          <td>
            <mat-icon color="primary" style="vertical-align: middle">mail</mat-icon>
          </td>
          <td>
            <a href="mailto:plattform-support@drklein.de">plattform-support@drklein.de</a>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
<div class="background-img bottom-left-rectangle"></div>
<div class="background-img bottom-right-rectangle"></div>
</div>
<div class="footer">
  <a href="https://www.drklein.de/datenschutz.html">Datenschutz</a>
  &nbsp;·&nbsp;
  <a href="https://www.drklein.de/agb.html">AGB</a>
  &nbsp;·&nbsp;
  <a href="https://www.drklein.de/impressum.html">Impressum</a>
</div>
